<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<h1 class="mb-2">Add Risk</h1>
			</v-col>

			<v-col align="center">
				<v-form v-model="valid">
					<v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Risk" v-model="risk" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Risk Description" v-model="riskdescription"
								:rules="[rules.inputRules, rules.maxWords]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Types of Risk" v-model="typesofrisk"
								:rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field outlined label="Risk Owner" v-model="riskowner" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Created" v-model="createddate"
								:rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field outlined label="Creator" v-model="creator" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="number" outlined label="Consequence: select a number between (0-25)"
								v-model="consequence" :rules="[rules.inputRules , rules.maxConsequence , rules.isInteger]" />
						</v-col>
						<v-col>
							<v-text-field type="number" outlined label="Probability:  select a number between (0-25)"
								v-model="probability" :rules="[rules.inputRules , rules.maxProbability, rules.isInteger]" />
						</v-col>
						<!-- <v-col>
						<v-alert color="primary" type="info">
							Note: <b>{{ (risk || riskdescription) ? risk + " " + riskdescription : "The new user" }}</b> must
							verify their e-mail address before logging in. A verification e-mail will be sent to
							<b>{{ typesofrisk || "their e-mail" }}</b> when you click 'Add user'
						</v-alert>
					</v-col> -->
						<v-col  align="right">
							<v-btn class="mr-10" color="primary"
								@click="addRisk(risk, riskdescription, typesofrisk, riskowner, createddate, creator, consequence, probability)"
								:disabled="!valid">
								Add Risk</v-btn>
						</v-col>
					</v-col>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { riskAPI } from "../api/csr/risk"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Add user",
	data() {
		return {
			show: false,
			valid: false,
			valid2: false,
			typesofrisk: "",
			riskowner: "",
			consequence: "",
			createddate: "",
			creator: "",
			risk: "",
			riskdescription: "",
			probability: null,
			updatedcreateddate: null,
			updatedconsequence: null,
			updatedprobability: null,
			rules: {
				inputRules: v => !!v || "Field is required!",
				maxConsequence: v => (v <= 25) || "Value must be 25 or less",
				maxProbability: v => (v <= 25) || "Value must be 25 or less",
				isInteger: v => Number.isInteger(Number(v)) || "Value must be an integer",
				maxWords: v => (v.split(/\s+/).length <= 20) || "Risk description can only contain up to 20 words"
			},
			rules2: {
				inputRules2nd: v => !!v || "Field is required!",
			}
		}
	},
	computed: {
		matrixID() {
			return this.$route.query.matrixID || null
		}
		
	},
	mounted() {
		console.log("ID in the Add New Risk:", this.matrixID) // Log the matrixID to the console
		this.$store.commit("setSelectedNewstate", true)
	},
	methods: {
		addRisk(risk, riskdescription, typesofrisk, riskowner, createddate, creator, consequence, probability) {
			console.log("MatrixID:", this.matrixID) // Log MatrixID to the console

			riskAPI.createRisk(this.matrixID, risk, riskdescription, typesofrisk, riskowner, createddate, creator, consequence, probability)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully added Risk!",
						{ root: true },
					)
					this.$router.push({ name: "riskpage" })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		updatedRisk: function (updatedcreateddate, updatedconsequence, updatedprobability) {
			console.log(updatedcreateddate, updatedconsequence, updatedprobability)
		},
	}
}
</script>
<style scoped>
	.v-application .mr-10 {
		margin-right: 0px !important;
		margin-left: 40px !important;
	}
</style>
